import { useState, useCallback } from 'react';

export const useGlossary = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrollToItem, setScrollToItem] = useState<string | undefined>();

  const openGlossary = useCallback((itemId?: string) => {
    setScrollToItem(itemId);
    setIsOpen(true);
  }, []);

  const closeGlossary = useCallback(() => {
    setIsOpen(false);
    setScrollToItem(undefined);
  }, []);

  return {
    isOpen,
    scrollToItem,
    openGlossary,
    closeGlossary
  };
};